// extracted by mini-css-extract-plugin
export default {"renderer":"html-renderer_renderer__tsdL2"};